module.exports = __webpack_public_path__ + "img/about_right.5235dac1.png";